import {ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ApiService} from "../../../../services/api.service";

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileUploaderComponent),
      multi: true
    }
  ]
})
export class FileUploaderComponent implements OnInit, ControlValueAccessor {

  @Input() readOnly: boolean = false;
  @Input() type: 'file' | 'photo' | 'video' | 'media';
  @Input() message: string;
  @Input() url: string = '';
  @Input() size: string = 'small';

  value: string[] = [];

  onChange: any = () => {}
  onTouch: any = () => {}

  constructor(public api: ApiService, public ref: ChangeDetectorRef) { }

  ngOnInit(): void {
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  writeValue(obj: string[]): void {
    if(obj){
      this.value = obj;
    }
  }

  handleChange(data: any){


  }

  removeFile(index: number){
    this.value.splice(index,1);
    this.ref.detectChanges();
    this.onChange(this.value);
  }

  uploadFile = (item: any): any => {
    const formData = new FormData();
    formData.append('image', item.file as any);
    this.api.apiPost(this.url, formData, true).then(
      (res: any) => {
        console.log(res);
        this.value.push(res.Success);
        console.log(this.value);
        this.onChange(this.value);
        this.ref.markForCheck();
      }
    ).catch((err: any) => {
      console.log(err);
      item.onError(err, item.file);
    });
  }

  isImage(data: string){

    const dataitem = data.split('.');
    const item = dataitem[dataitem.length - 1];

    return !(
      item === 'mp4' ||
      item === 'avi' ||
      item === 'mov' ||
      item === 'webm' ||
      item === 'asf' ||
      item === '3gp' ||
      item === 'm4v'
    );


  }

}
